import { render, staticRenderFns } from "./newCommunityWaterApply_report.vue?vue&type=template&id=270c8184"
import script from "./newCommunityWaterApply_report.vue?vue&type=script&lang=js"
export * from "./newCommunityWaterApply_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports